export const TYPES_FIGURANT = {
  FIGURANTE: 'BACKGROUND_ACTOR',
  MENOR: 'UNEMANCIPATED_MINOR',
  MENOR_EMANCIPADO: 'MINOR',
  ESTRANGEIRO: 'FOREIGNER',
  ANIMAL: 'PET',
  VEICULO: 'VEHICLE',
  FISCAL: 'FISCAL',
};

export const TYPE_FIGURANT_NAME = {
  BACKGROUND_ACTOR: 'Comum',
  UNEMANCIPATED_MINOR: 'Menor de idade',
  MINOR: 'Menor de idade (emancipado)',
  FOREIGNER: 'Estrangeiro',
};

export const TYPES_FIGURANT_ID = {
  '1': 'Figurante',
  '2': 'Veículo',
  '3': 'Animal',
  '4': 'Fiscal',
  '5': 'Menor',
  '8': 'Modelo profissional',
  '9': 'Auxiliar plateia',
  '10': 'Figurante SP',
};

export const ORDER_STATUS = {
  CLIMBED: 'Escalado',
  CANCELED: 'Cancelado',
  SENT: 'Enviado',
};

export const TYPE_FIGURANTS = {
  BACKGROUND_ACTOR: 1,
  MINOR: 3,
  UNEMANCIPATED_MINOR: 2,
  FISCAL: 7,
  FOREIGNER: 4,
  PROFESSIONAL_MODEL: 8,
  AUDIENCE_ASSISTANT: 9,
  FIGURANTE_SP: 10,
};

export const FIGURANTS_EXCEED_LIMIT = 59;
